import React from 'react';
import { colors, typography } from '@moda/tokens';
import classNames from 'classnames';
import { titleize } from '@moda/portal-stanchions';

const TOTAL_HEIGHT = 6.15;

export interface VisualStyleFilterShapeLayoutProps {
  className?: string;
  children: string;
}

export const VisualStyleFilterShapeLayout: React.FC<VisualStyleFilterShapeLayoutProps> = ({
  children,
  className
}) => {
  if (!children || typeof children.split !== 'function') return null;

  const words = children.split(' ');

  return (
    <svg
      className={classNames('VisualStyleFilterShapeLayout', className)}
      width="58"
      height={`${TOTAL_HEIGHT}rem`}
      viewBox="0 -1 58 114"
      fill="none"
    >
      <path
        clipRule="evenodd"
        d="M57.619 98.305V11.4966H51.789C46.5523 4.52527 38.2796 0 28.9387 0C19.597 0 11.3243 4.52527 6.08764 11.4966H0V98.305H5.94033C11.1679 105.389 19.5089 110 28.9387 110C38.3677 110 46.7087 105.389 51.9363 98.305H57.619Z"
        fill="#F9F5ED"
        fillRule="evenodd"
      />
      <text
        fontSize={typography['root-font-size']}
        fill={colors.all.ink}
        fontFamily={typography.fonts.serif[0]}
        textAnchor="middle"
        strokeWidth="1px"
        y={`${TOTAL_HEIGHT / 2 - words.length / 2}em`}
      >
        {words.map((word, index) => (
          <tspan key={index} x="50%" dy="1.25em">
            {titleize(word)}
          </tspan>
        ))}
      </text>
    </svg>
  );
};
